export default {"src":"/_next/static/media/0xd4d42f0b6def4ce0383636770ef773390d85c61a.6d8b1f8f.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};